<div class="section-container" *ngIf="shouldShowPrices()">
  <h3 class="section-title">Selected type</h3>
  <div [formGroup]="formGroup">
    <div class="radio-group">
      <ng-container *ngFor="let precioControl of pricesFormGroups; let i = index">
        <label class="radio-row">
          <div class="col-name">
            <span class="radio-name">{{ precioControl.get('nombre')?.value ?? 'Normal' }}</span>
          </div>
          <div class="col-no"></div>
          <div class="col-add"></div>
          <div class="col-extra radio-extra">
            <span class="old-price" *ngIf="hasDiscount(precioControl)">
              {{ precioControl.get('specialPriceAmount')?.value | integerToFloat | currency: 'USD' : 'symbol' : decimalPrecision }}
            </span>
            <span class="current-price">
              {{ precioControl.get('precio')?.value | integerToFloat | currency: 'USD' : 'symbol' : decimalPrecision }}
            </span>
            <div class="custom-radio-wrapper">
              <input type="radio" formControlName="selectedPriceIndex" [value]="i" class="custom-radio">
              <span class="radio-circle"></span>
            </div>
          </div>
        </label>
      </ng-container>
    </div>
  </div>
</div>
